import type { FilterDefinition } from '@/components/filters/list-filter-types'
import { FilterOptionList } from '@/components/filters/filter-menu'
import type { AccessRequestStatus } from '@/hooks/use-access-requests'

export type AdminWaitlistFilterState = {
  search: string
  status: AccessRequestStatus | ''
}

export type AdminWaitlistFilterCtx = {
  counts: Partial<Record<AccessRequestStatus, number>>
}

export const ADMIN_WAITLIST_STATUS_OPTIONS: Array<{ value: AccessRequestStatus | 'all'; label: string }> = [
  { value: 'all', label: 'All' },
  { value: 'pending', label: 'Pending' },
  { value: 'session_sent', label: 'Session sent' },
  { value: 'invited', label: 'Invited' },
  { value: 'converted', label: 'Converted' },
  { value: 'rejected', label: 'Rejected' },
]

function statusOptionLabel(
  option: { value: AccessRequestStatus | 'all'; label: string },
  counts: Partial<Record<AccessRequestStatus, number>>,
): string {
  if (option.value === 'all') return option.label
  const count = counts[option.value]
  return count != null ? `${option.label} (${count})` : option.label
}

export const ADMIN_WAITLIST_FILTER_DEFINITIONS: FilterDefinition<
  AdminWaitlistFilterState,
  AdminWaitlistFilterCtx
>[] = [
    {
      key: 'status',
      label: 'Status',
      displayValue: (filters, ctx) => {
        const option = ADMIN_WAITLIST_STATUS_OPTIONS.find(
          (opt) => opt.value === (filters.status || 'all'),
        )
        return option ? statusOptionLabel(option, ctx.counts) : 'All'
      },
      isNonDefault: (filters) => Boolean(filters.status),
      reset: (filters) => ({ ...filters, status: '' }),
      renderPopover: ({ filters, onChange, ctx }) => (
        <FilterOptionList
          type="single"
          options={ADMIN_WAITLIST_STATUS_OPTIONS.map((option) => ({
            value: option.value,
            label: statusOptionLabel(option, ctx.counts),
          }))}
          value={filters.status || 'all'}
          onValueChange={(value) =>
            onChange({ ...filters, status: value === 'all' ? '' : (value as AccessRequestStatus) })
          }
        />
      ),
    },
  ]
